module.exports = __webpack_public_path__ + "static/media/ak47Content.544b4e15.png";